import React, { lazy, Suspense } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Nav from "./components/Nav/Nav";
// import Footer from "./components/Footer/Footer";
import Loading from "./components/Loading/Loading";
import ScrollToTop from "./ScrollToTop";

const AdminHome = lazy(() => import("./pages/AdminHome"));
const AdminAccount = lazy(() => import("./pages/AdminAccount"));
const AdminCoach = lazy(() => import("./pages/AdminCoach"));
const AdminClinics = lazy(() => import("./pages/AdminClinics"));
const AdminSelectedClinic = lazy(() => import("./pages/AdminSelectedClinic"));
const AdminNews = lazy(() => import("./pages/AdminNews"));
const AdminSelectedNews = lazy(() => import("./pages/AdminSelectedNews"));
const AdminGeneral = lazy(() => import("./pages/AdminGeneral"));
const AdminEmail = lazy(() => import("./pages/AdminEmail"));

const Router = () => {
  // window.onbeforeunload = () => {
  //   localStorage.removeItem("token");
  // };
  function RequireAuth({ children }) {
    const token = localStorage.getItem("tokenadmin");
    let location = useLocation();

    if (!token) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    return children;
  }

  return (
    <BrowserRouter>
      <Nav />
      <ScrollToTop />
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route exact path="/" element={<AdminHome />} />
          <Route
            exact
            path="/account"
            element={
              <RequireAuth>
                <AdminAccount />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/account/coach"
            element={
              <RequireAuth>
                <AdminCoach />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/account/clinics"
            element={
              <RequireAuth>
                <AdminClinics />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/account/clinics/clinic"
            element={
              <RequireAuth>
                <AdminSelectedClinic />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/account/news"
            element={
              <RequireAuth>
                <AdminNews />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/account/news/selected"
            element={
              <RequireAuth>
                <AdminSelectedNews />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/account/geninfo"
            element={
              <RequireAuth>
                <AdminGeneral />
              </RequireAuth>
            }
          />
          <Route
            exact
            path="/account/email"
            element={
              <RequireAuth>
                <AdminEmail />
              </RequireAuth>
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
